const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class PushCartCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.setupCarousel()
      }, 500),
    )

    if (this.carousel) {
      this.listeners.add(this.carousel.container, 'slide.change', () => {
        this.updateSlideAccessibility()
      })
    }
  }

  updateSlideAccessibility () {
    if (!this.els.slide?.exists) return

    const slides = this.els.slide?.elements || []
    const slideIndex = this.carousel?.track?.details?.rel || 0

    slides.forEach((slide, index) => {
      const isVisible = index === slideIndex

      slide.setAttribute('aria-current', String(isVisible))

      if (isVisible) {
        slide.setAttribute('aria-hidden', 'false')
        slide.removeAttribute('tabindex')

        // Make all focusable elements accessible
        const focusableElements = slide.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        )
        focusableElements.forEach((el) => {
          el.removeAttribute('tabindex')
        })
      } else {
        slide.setAttribute('aria-hidden', 'true')
        slide.setAttribute('tabindex', '-1')

        // Hide all focusable elements from keyboard navigation
        const focusableElements = slide.querySelectorAll(
          'button, [href], input, select, textarea',
        )
        focusableElements.forEach((el) => {
          el.setAttribute('tabindex', '-1')
        })
      }

      // Keep selected state explicit for screen readers on visible product-type links.
      const productTypeLinks = slide.querySelectorAll(
        'a[href]:not([aria-hidden="true"])',
      )

      productTypeLinks.forEach((link) => {
        link.setAttribute('aria-current', String(isVisible))

        let selectedText = link.querySelector(
          '[data-push-cart-carousel-el="selected-text"]',
        )

        if (!selectedText) {
          selectedText = document.createElement('span')
          selectedText.className = 'util-ScreenReaderOnly'
          selectedText.setAttribute(
            'data-push-cart-carousel-el',
            'selected-text',
          )
          link.appendChild(selectedText)
        }

        selectedText.textContent = isVisible ? ' (Selected)' : ''
      })
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    if (window.BAO.MediaBreakpoints.isSm) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.1,
          spacing: 14,
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('push-cart-carousel')) {
  customElements.define('push-cart-carousel', PushCartCarousel)
}
